import React from 'react';
import {classes, style, vars} from './doppe-action-media-overlay-button.st.css';
import {Button} from "@wix/devzai-utils-react";
import {BymoPageStyleScopeColors, useBymoPageScopeColor} from "../bymo-page-style/bymo-page-style";
import {colorResolveLegibleForegroundColor} from "@wix/devzai-utils-common";

export const DoppeActionMediaOverlayButton = React.memo(function DoppeActionMediaOverlayButton (props: DoppeActionMediaOverlayButton.Props) {
    const {
        className,
        children,
        ...htmlAttributes
    } = props;

    // The background of the button is the scoped text color of the scope
    const backgroundColor = useBymoPageScopeColor(BymoPageStyleScopeColors.TextColor);

    return (
        <Button
            {...htmlAttributes}
            className={style(classes.roundness, classes.root, className)}
            style={{
                [vars.backgroundColor]: backgroundColor,
                [vars.textColor]: colorResolveLegibleForegroundColor(backgroundColor)
            }}
        >
            {children}
        </Button>
    );
});

export namespace DoppeActionMediaOverlayButton {
    export interface Props extends Button.Props {
    }
}
